import { render } from "./AdminCardCatalog.vue?vue&type=template&id=20fb1bae"
import script from "./AdminCardCatalog.vue?vue&type=script&lang=js"
export * from "./AdminCardCatalog.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__